import { createAsyncThunk } from '@reduxjs/toolkit'
import { getSettings } from 'src/apiHelper/settingsApi'
import { getCollector } from '../../apiHelper/collectorApi'
import { processVisits } from '../../apiHelper/Dataformatter/util'
import { COLLECTOR_URL } from '../../apiHelper/apiRoute/collector'
import { SETTINGS_URL } from '../../apiHelper/apiRoute/settings'
import { toast } from 'react-toastify'

export const getVisitsCensus = createAsyncThunk(
  'census/getVistByServiceDate',
  async (reqData, thunkAPI) => {
    try {
      if (!reqData.servicedate || reqData.servicedate?.length !== 10) {
        toast.dismiss()
        return toast.error('Invalid date chosen ' + reqData.servicedate)
      }

      if (Object.keys(thunkAPI.getState()?.census?.visitStatuses || {}).length === 0) {
        thunkAPI.dispatch(getBetaVisitStatus())
      }

      const url = COLLECTOR_URL.CENSUS_LIST.replace('{serviceDate}', reqData.servicedate)
        .replace('{facility_id}', reqData.facility_id)
        .replace(
          '{showRecentlyDischarged}',
          thunkAPI.getState()?.user?.settings?.showRecentlyDischarged,
        )

      const facExists = Boolean(reqData.facility_id)
      const docByFacilityUrl = COLLECTOR_URL.GET_DOCUMENT_BY_FACILITY.replace(
        '{service_date}',
        reqData.servicedate,
      ).replace('{facilityIds}', [reqData.facility_id])

      const results = await Promise.allSettled([
        getCollector(url),
        // don't waste a call if there is no facility to get
        facExists ? getCollector(docByFacilityUrl) : async () => {},
      ])
      const [resVisits, docsByFacility] = results.map((result) => {
        if (result.status === 'fulfilled') {
          return result.value
        }
        console.error(result.reason)
        return null
      })

      const visitStatuses = thunkAPI.getState()?.census?.visitStatuses || {}

      let inPatients = []
      if (resVisits?.status === 'success') {
        // TODO what does this actually do
        if (reqData?.thisProvider) {
          inPatients = processVisits(
            resVisits?.resData,
            visitStatuses,
            {
              showSmartCensus: thunkAPI.getState()?.user?.settings?.showSmartCensus,
            },
            false,
          )
        } else {
          inPatients = processVisits(resVisits?.resData, visitStatuses, {
            showSmartCensus: thunkAPI?.getState()?.user?.settings?.showSmartCensus,
          })
        }
      }

      return {
        service_date: resVisits?.service_date,
        inPatients,
        docByFacilityList: docsByFacility?.result?.[0]?.files || [],
        fileDisplayName: docsByFacility?.result?.[0]?.display_name,
      }
    } catch (err) {
      console.log('getting error in rendering census', err)
      return false
    }
  },
)
export const getBetaVisitStatus = createAsyncThunk('census/getBetaVisitStatus', async () => {
  try {
    const resStatuses = await getSettings(SETTINGS_URL.GET_VISIT_STATUS)
    if (resStatuses?.status === 500) {
      return 'Server Error'
    } else {
      if (resStatuses?.status === 'success') {
        return {
          visitStatuses: resStatuses,
        }
      }
    }
  } catch (err) {
    console.log('getting error in getBetaVisitStatus', err)
    return false
  }
})
export const getDischargeCodes = createAsyncThunk('census/getDischargeCodes', async () => {
  try {
    const resStatuses = await getSettings(SETTINGS_URL.GET_DISCHARGE_CODES)
    if (resStatuses?.status === 500) {
      return 'Server Error'
    } else {
      if (resStatuses?.status === 'success') {
        return {
          dischargeCodes: resStatuses,
        }
      }
    }
  } catch (err) {
    console.log('getting error in getDischargeCodes', err)
    return false
  }
})

export const getDocuments = createAsyncThunk('census/getDocuments', async (reqData) => {
  try {
    const docByFacilityUrl = COLLECTOR_URL.GET_DOCUMENT_BY_FACILITY.replace(
      '{service_date}',
      reqData.servicedate,
    ).replace('{facilityIds}', [reqData.facility_id])
    const docByFacilityList = await getCollector(docByFacilityUrl)

    if (docByFacilityList?.status === 500) {
      return 'Server Error'
    } else {
      if (docByFacilityList?.status === 'success') {
        return {
          docByFacilityList: docByFacilityList?.result[0]?.files || [],
          fileDisplayName: docByFacilityList?.result[0]?.display_name || [],
        }
      }
    }
  } catch (err) {
    console.log('getting error in rendering census', err)
    return false
  }
})

export const getFacilities = createAsyncThunk('census/getFacilities', async () => {
  try {
    const resFacilities = await getSettings(SETTINGS_URL.FACILITIES_BY_PROVIDER)
    if (resFacilities?.status === 500) {
      return 'Server Error'
    } else {
      if (resFacilities?.status === 'success') {
        return {
          allFacilitiesList: resFacilities.results.filter((fac) => fac.enabled),
        }
      }
    }
  } catch (err) {
    console.log('getting error in getFacilities', err)
    return false
  }
})

export const getDiagnosisByVisitId = createAsyncThunk(
  'census/getDiagnosisByVisitId',
  async (visitId) => {
    try {
      const endpoint = COLLECTOR_URL.GET_DIAGNOSIS_BY_VISIT_ID.replace('{visitId}', visitId)
      let diagnosisSearchResult = await getCollector(endpoint)
      if (diagnosisSearchResult?.status === 500) {
        return 'Server Error'
      } else {
        if (diagnosisSearchResult?.status === 'success') {
          return diagnosisSearchResult.results ? diagnosisSearchResult.results : []
        }
      }
    } catch (err) {
      console.log('getting error in rendering getDiagnosisByVisitId', err)
      return false
    }
  },
)

export const getCptByVisitId = createAsyncThunk('census/getCptByVisitId', async (visitId) => {
  try {
    const endpoint = COLLECTOR_URL.GET_CPT_BY_VISIT_ID.replace('{visitId}', visitId)
    let cptSearchResult = await getCollector(endpoint)
    if (cptSearchResult?.status === 500) {
      return 'Server Error'
    } else {
      if (cptSearchResult?.status === 'success') {
        return cptSearchResult.results ? cptSearchResult.results : []
      }
    }
  } catch (err) {
    console.log('getting error in rendering getCptByVisitId', err)
    return false
  }
})
